<template>
  <div class="profile-select-wrapper" ref="profileWrapper">
    <!--서브 상단 타이틀 -->
    <div class="intro-profile-wrap">
      <h2 class="intro-prodile-hd">사용자 선택</h2>
      <p class="intro-prodile-help">시청할 프로필을 선택하세요.</p>

      <div class="intro-profile-list">
        <ul>
          <li v-for="(profile, index) in profiles" :key="'profile_' + index" @click.prevent="()=>selectProfile(profile)">
            <span class="intro-profile-info">
                <button type="button" :class="'intro-profile-img' + (+userInfo.profileid === index ? ' ch-profile' : '')">
                    <img :src="'https://' +  profile.image" :alt="profile.alt">
                </button>
                <span class="intro-profile-txt">{{profile.profilename}}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { UserService } from '@/common/api/api.service'
import utils from '@/common/util/utils'
import { displayNone, removeNone } from '@/common/util/ui.utils'

export default {
  name: 'ProfileSelect',
  props: {
    closeFn: {
      type: Function
    }
  },
  data () {
    return {
      userInfo: {},
      profiles: []
    }
  },
  methods: {
    close () {
      removeNone('.login-mode')
      this.closeFn()
    },
    selectProfile (profile) {
      if (this.userInfo.profileid === profile.profileid) {
        this.close()
      } else {
        let res = utils.login.changeProfileProc(profile.profileid)
        if (res !== null) {
          res.then(() => {
            this.close()
          })
        }
      }
    },
    setUserInfoData () {
      UserService.userInfo().then(({ data }) => {
        this.userInfo = data
      })
      UserService.profiles({ offset: 0, limit: 10, orderby: 'new', credential: utils.cookies.userInfo('credential') }).then(({ data }) => {
        this.profiles = data.list
      })
    }
  },

  created () {
    window.scrollTo(0, 0)
    this.setUserInfoData()
    displayNone('.login-mode')
  }
}
</script>

<style scoped>
  .profile-select-wrapper {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #1b1b1b;
    z-index: 5000;
  }

  /*------------------------------------*\
      서브 상단 header : home-gnb.css와 동일 -> 추후 정리
  \*------------------------------------*/
  .hd-title{
    display: block;
    font-size: 16px;
    line-height: 24px;
    color: #23212a;
    text-align: center
  }

  /*------------------------------------*\
      사용자 선택
  \*------------------------------------*/
  .intro-prodile-hd{
    padding-top: 50px;
    text-align: center;
    color: #fff;
    font-size: 18px
  }
  .intro-prodile-help{
    margin-top: 10px;
    text-align: center;
    color: #a5a5a5;
    font-size: 12px
  }
  .intro-profile-list{
    padding: 40px 28px 48px
  }
  .intro-profile-list li{
    display: inline-block;
    width: 50%;
    padding: 0 20px 40px;
    text-align: center;
    vertical-align: top;
  }
  .intro-profile-info{
    display: block;
    margin: 0 5px
  }
  .intro-profile-txt{
    display: block;
    display: -webkit-box;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    margin-top: 20px;
    color: #a5a5a5;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
  }
  .intro-profile-info img {
    max-width: 100%;
    width: 120px;
    display: block;
  }
  .intro-profile-info button {
    position: relative;
  }
  span.checked {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    margin-top: -20px;
    margin-left: -25px;
  }
</style>
